var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossDualGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.6066 6.7059L6.70711 16.6054C6.31658 16.9959 6.31658 17.6291 6.70711 18.0196C7.09763 18.4101 7.7308 18.4101 8.12132 18.0196L18.0208 8.12011C18.4113 7.72959 18.4113 7.09642 18.0208 6.7059C17.6303 6.31537 16.9971 6.31537 16.6066 6.7059Z",
    fill: "#A1A5B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0207 16.6066L8.12117 6.70711C7.73064 6.31658 7.09748 6.31658 6.70696 6.70711C6.31643 7.09763 6.31643 7.7308 6.70696 8.12132L16.6065 18.0208C16.997 18.4113 17.6301 18.4113 18.0207 18.0208C18.4112 17.6303 18.4112 16.9971 18.0207 16.6066Z",
    fill: "#A1A5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossDualGreyIcon);
export default __webpack_public_path__ + "static/media/cross-dual-grey-icon.715bd5cdb85aa786caf3a5ddb1d95190.svg";
export { ForwardRef as ReactComponent };